import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import PushPinIcon from '@mui/icons-material/PushPin';
import CloseIcon from '@mui/icons-material/Close';
import type { CommunityMessage } from '../../services/communityService';

interface PinnedMessageBannerProps {
  message: CommunityMessage;
  onScrollTo: () => void;
  onUnpin: () => void;
}

function bannerText(msg: CommunityMessage): string {
  if (msg.message_type === 'deleted' || msg.deleted) return 'Pinned message was deleted';
  if (msg.content?.trim()) return msg.content.trim();
  if (msg.forwarded_from?.content_snippet) return msg.forwarded_from.content_snippet;
  return 'Pinned message';
}

export const PinnedMessageBanner: React.FC<PinnedMessageBannerProps> = ({
  message,
  onScrollTo,
  onUnpin,
}) => (
  <Box
    sx={{
      mx: 2,
      mt: 1,
      mb: 0.5,
      px: 1.5,
      py: 1,
      bgcolor: '#fff',
      borderRadius: 2,
      border: '1px solid #e8eaed',
      display: 'flex',
      alignItems: 'center',
      gap: 1,
      cursor: 'pointer',
      boxShadow: '0 1px 2px rgba(0,0,0,0.06)',
    }}
    onClick={onScrollTo}
  >
    <PushPinIcon sx={{ fontSize: 18, color: '#0f9d58', transform: 'rotate(45deg)' }} />
    <Box sx={{ flex: 1, minWidth: 0, borderLeft: '3px solid #0f9d58', pl: 1 }}>
      <Typography sx={{ fontSize: '0.72rem', fontWeight: 600, color: '#0f9d58' }}>
        Pinned message
      </Typography>
      <Typography
        sx={{
          fontSize: '0.8rem',
          color: '#5f6368',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {bannerText(message)}
      </Typography>
    </Box>
    <IconButton
      size="small"
      onClick={(e) => {
        e.stopPropagation();
        onUnpin();
      }}
      aria-label="Unpin message"
    >
      <CloseIcon fontSize="small" />
    </IconButton>
  </Box>
);
